import axios, { AxiosError } from "axios";
import { ApiResponse } from "../models/api_response";
import { endpoint } from "./base_url";

export async function resendOTP(
  registrationID: string
): Promise<ApiResponse | undefined> {
  try {
    const response = await axios.post(
      `${endpoint}/resendOTP`,
      {
        registrationID: registrationID,
      }
    );
    return {
      statusCode: response.status,
      responseBody: response.data.content,
    };
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        statusCode: error.response!.status,
        responseBody: error.response?.data.content,
      };
    }
    console.log(error);
    return undefined;
  }
}
